export const RecordingTypes =
  'webcam_recording screen_recording audio_recording';
